// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"5b67e6da","419":"a28bd0b3","563":"5d3670bb","787":"2f31f199","942":"3577365b"}[chunkId] + ".chunk.js";
};